// extracted by mini-css-extract-plugin
export default {"errorMessage":"Error_errorMessage__OLpUH","floating":"Error_floating__Wnc69"};